import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.List.IRequest;
type Response = Api.Core.ProductPricingPlan.List.IResponse;
type Headers = Api.Core.ProductPricingPlan.List.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlan';
export default async function productPricingPlanListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
